// Behaviour for the shared file picker tile (Views/Shared/Widgets/_FilePicker.cshtml; look in
// less/widgets/file-picker.less): previews the chosen file, flips the tile to its has-file state, accepts a
// file dropped onto it, enforces an optional size limit and fills an optional "not saved yet" cue.
//
// Only tiles carrying the data-file-picker marker are enhanced - other pages use the widget's markup with
// their own handlers (e.g. the claimant profile image dialog) and must not be double-bound. Tiles present
// at DOM ready are enhanced automatically; a page that renders one later (e.g. into an AJAX-loaded
// partial) calls VoterFly.UI.enhanceFilePickers(container) itself. Enhancing is idempotent.
(function () {
    const ENHANCED_FLAG = 'filePickerEnhanced';

    function formatMegabytes(bytes) {
        return Math.round(bytes / (1024 * 1024)) + ' MB';
    }

    function enhanceFilePicker(pickerElem) {
        const $picker = $(pickerElem);

        if ($picker.data(ENHANCED_FLAG)) {
            return;
        }

        $picker.data(ENHANCED_FLAG, true);

        const $input = $picker.find('.file-picker-input');
        const $preview = $picker.find('.file-picker-preview');
        const $placeholder = $picker.find('.file-picker-placeholder');

        const maxSizeBytes = parseInt($picker.attr('data-max-size'), 10);
        const hasSizeLimit = !isNaN(maxSizeBytes) && maxSizeBytes > 0;

        const fileNameTargetId = $picker.attr('data-filename-target');
        const $fileNameTarget = fileNameTargetId ? $('#' + fileNameTargetId) : $();

        let currentObjectUrl = null;

        // Swaps the tile to the chosen image before upload so the user sees what they picked.
        function showPreview(file) {
            if (currentObjectUrl) {
                URL.revokeObjectURL(currentObjectUrl);
            }

            currentObjectUrl = URL.createObjectURL(file);

            $preview.attr('src', currentObjectUrl).show();
            $placeholder.hide();
            $picker.addClass('has-file');
        }

        $input.on('change', function () {
            const file = this.files && this.files[0];

            if (!file) {
                return;
            }

            const exceedsSizeLimit = hasSizeLimit && file.size > maxSizeBytes;

            if (exceedsSizeLimit) {
                alert('That file is too large. Files up to ' + formatMegabytes(maxSizeBytes) + ' may be uploaded.');
                this.value = '';
                return;
            }

            showPreview(file);

            $fileNameTarget.text(file.name + ' — save to apply').show();
        });

        // Drag and drop onto the tile. The dropped file is handed to the file input so the same change
        // handler validates and previews it.
        $picker.on('dragenter dragover', function (evt) {
            evt.preventDefault();
            $picker.addClass('dragover');
        });

        $picker.on('dragleave drop', function (evt) {
            evt.preventDefault();
            $picker.removeClass('dragover');
        });

        $picker.on('drop', function (evt) {
            const droppedFiles = evt.originalEvent.dataTransfer.files;

            if (droppedFiles.length > 0) {
                $input.prop('files', droppedFiles);
                $input.trigger('change');
            }
        });
    }

    VoterFly.UI.enhanceFilePickers = function (root) {
        const $root = $(root || document);
        const $pickersWithin = $root.find('[data-file-picker]');
        const $pickers = $pickersWithin.addBack('[data-file-picker]'); // root may itself be the tile

        $pickers.each(function (idx, elem) {
            enhanceFilePicker(elem);
        });
    };

    $(function () {
        VoterFly.UI.enhanceFilePickers(document);
    });
})();
